import { useBackendQuery as useQuery } from "@/hooks/useBackendQuery";

import { IObjectWithTypename } from "@/components/@types";
import { NodeLayout } from "@/components/organisms/Node/NodeLayout";
import { useNode, useNodeSetup } from "@/components/organisms/Node/Node.hooks";
import { Queries } from "@/constants";
import { useScope } from "@/hooks/useScope";
import { State } from "@/state";

import { SettingsViewLayout } from "./SettingsViewLayout";

export function SettingsProfileView() {
  const { user } = useScope();
  const nodeId = user?.profile?.id;

  const { data, loading: isLoading } = useQuery(Queries.NODE_QUERY, {
    variables: nodeId
      ? {
          id: nodeId,
          startDate: State.getState().timeSeriesFilter.startDate?.toISOString(),
          endDate: State.getState().timeSeriesFilter.endDate?.toISOString(),
        }
      : undefined,
    skip: !nodeId,
  });

  const { store } = useNodeSetup({
    mode: "update",
    node: data?.node as IObjectWithTypename,
    typename: "UserProfileObject",
  });
  const { actions, metadata } = useNode(store);

  return (
    <SettingsViewLayout
      store={store}
      title={metadata.title}
      isLoading={isLoading}
      actions={actions}
    >
      <NodeLayout
        autofocus={true}
        store={store}
        isLoading={isLoading}
        isSingleClick={true}
        forceLayoutMode="cards"
      />
    </SettingsViewLayout>
  );
}
